/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 09:22:51
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-05-08, 13:27:10
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import users from "./users";
import baners from "./baners";
import groups from "./groups";
import brands from "./brands";
import clients from "./clients";
import statuses from "./statuses";
import settings from "./settings";
import complains from "./complains";
import blackList from "./blackList";
import recharges from "./recharges";
import dictionary from "./dictionary";
import authorization from "./authorization";
import complainsTitles from "./complainsTitles";
import complainsCategories from "./complainsCategories";
import confirmation from "./confirmation";

var reducer = {
  users,
  baners,
  groups,
  brands,
  clients,
  statuses,
  settings,
  recharges,
  complains,
  blackList,
  dictionary,
  authorization,
  complainsTitles,
  complainsCategories,
  confirmation,
  routing: routerReducer
};

export default combineReducers(reducer);


// WEBPACK FOOTER //
// ./src/rcapp/redux/actions/reducer.js